module.exports = __webpack_public_path__ + "img/monitor.a0ae9227.svg";